<template>
  <div class="about">
    <h1>Hello world</h1>
  </div>
</template>
